import React, { useCallback, useEffect } from 'react';
import ClaimsList from '../../components/claimsList/claimsList';
import {
    clearAnswersState,
    clearClaimCategoryState,
    clearClaimTypesState,
    fetchClaimApplications,
} from '../../actions';
import { useHistory } from 'react-router-dom';
import usePagination from '../../hooks/usePagination';
import claimApplicationProjections from '../../projections/claimApplication';
import * as action from '../../actions';
import { useAppSelector, useAppDispatch } from '../../hooks/hooks';

import { LocationDescriptor } from 'history';

const ClaimsListContainer = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const claimApplicationsList = useAppSelector(
        claimApplicationProjections.claimApplicationList,
    );
    const pagination = useAppSelector(
        state => state.claimApplication.pagination,
    );
    const loading = useAppSelector(state => state.claimApplication.loading);
    const {
        pagerState,
        goAtPrevious,
        goAtNext,
        goAtEnd,
        goAtStart,
        goAtPage,
        handlePageSizeChange,
        setState,
    } = usePagination();

    const fetchClaimApplicationsAction = useCallback(
        (payload: action.fetchClaimApplicationsAction) =>
            dispatch(fetchClaimApplications(payload)),
        [dispatch],
    );

    const clearAnswersStateAction = useCallback(
        () => dispatch(clearAnswersState()),
        [dispatch],
    );

    const clearClaimCategoryStateAction = useCallback(
        () => dispatch(clearClaimCategoryState()),
        [dispatch],
    );

    const clearClaimTypesStateAction = useCallback(
        () => dispatch(clearClaimTypesState()),
        [dispatch],
    );

    const clearQuestionStateAction = useCallback(
        () => dispatch(action.clearQuestionState()),
        [dispatch],
    );
    useEffect(() => {
        clearQuestionStateAction();
    }, [clearQuestionStateAction]);

    useEffect(() => {
        fetchClaimApplicationsAction({
            page: pagerState.page,
            limit: pagerState.limit,
        });
    }, [fetchClaimApplicationsAction, pagerState.page, pagerState.limit]);

    useEffect(() => {
        if (pagination) {
            setState(pagination);
        }
    }, [pagination]);

    const onCreateNewClaim = () => {
        clearAnswersStateAction();
        clearClaimCategoryStateAction();
        clearClaimTypesStateAction();
        history.push('/claim');
    };

    const onClickViewDetails = (url: LocationDescriptor<string>) => {
        history.push(url);
    };

    const onClickResumeClaim = (claimApplicationId: string) => {
        history.push(`/claim/${claimApplicationId}`);
    };

    const onPageSizeChange = (evt: React.ChangeEvent<HTMLInputElement>) =>
        handlePageSizeChange(evt.target.value);
    return (
        <ClaimsList
            claimApplicationsList={claimApplicationsList}
            onClickResumeClaim={onClickResumeClaim}
            onClickViewDetails={onClickViewDetails}
            onCreateNewClaim={onCreateNewClaim}
            pager={pagerState}
            onPageSizeChange={onPageSizeChange}
            goAtPage={goAtPage}
            goAtStart={goAtStart}
            goAtEnd={goAtEnd}
            goAtNext={goAtNext}
            goAtPrevious={goAtPrevious}
            loading={loading}
        />
    );
};

export default ClaimsListContainer;
